import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Container, Row, Button, Stack } from 'react-bootstrap';
import { Formik, Form, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';
import { ActivationDateControl } from '@components/Feature/Quote';

import { useCorporateHealthQuoteFetch } from '../hook';
import { corporateHealthQuoteLock, CorporateHealthQuoteLockPayload } from '../action';
import { RightCol } from '../right-col';
import { FormValues } from './type';
import { useInitialValues, useValidationSchema } from './hook';

const CorporateHealthQuoteBuyLockPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const corporateHealthQuote = useCorporateHealthQuoteFetch();
  const initialValues = useInitialValues(corporateHealthQuote);
  const validationSchema = useValidationSchema();

  if (isUndefined(corporateHealthQuote)) return <Loading />;
  if (isNull(corporateHealthQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { orderNumber } = corporateHealthQuote;

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    const payload: CorporateHealthQuoteLockPayload = { orderNumber, ...values };
    dispatch(corporateHealthQuoteLock(payload));
    setSubmitting(false);
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ isSubmitting }) => (
              <Form>
                <Card>
                  <Card.Body>
                    <ActivationDateControl required />
                  </Card.Body>

                  <Card.Footer className="bg-white border-0 mx-auto my-4">
                    <Stack direction="horizontal" gap={3}>
                      <Button onClick={() => navigate(-1)} variant="outline-primary" size="lg">
                        {t('common:cancel')}
                      </Button>

                      <Button type="submit" variant="primary" size="lg" disabled={isSubmitting}>
                        {t('common:confirm')}
                      </Button>
                    </Stack>
                  </Card.Footer>
                </Card>
              </Form>
            )}
          </Formik>
        </Col>

        <RightCol corporateHealthQuote={corporateHealthQuote} />
      </Row>
    </Container>
  );
};

export { CorporateHealthQuoteBuyLockPage };
